const themeConfig: ThemeConfig.Config = {

  // primary: '#00c88c',
  primary: '#' + (import.meta.env.VITE_PRIMARY_COLOR || '00b51a'),
  followOs: false,
  draw: true,
  globalTheme: 'light',
  menuTheme: 'light',
  toolbarTheme: 'light',
  isToolbarDetached: false,
  isContentBoxed: false,
  isRTL: false,
  light: {
    dark: false,
    variables: {
      "high-emphasis-opacity": 0.92,
      "medium-emphasis-opacity": 0.68,
      "border-opacity": 0.08,
      "shadow-key-umbra-opacity": 0.04,
      "shadow-key-penumbra-opacity": 0.03,
      "shadow-key-ambient-opacity": 0.02,
    },
    colors: {
      background: '#' + (import.meta.env.VITE_BACKGROUND_COLOR || 'F4F7F6'),
      surface: '#ffffff',
      primary: '#' + (import.meta.env.VITE_PRIMARY_COLOR || '00b51a'),
      secondary: '#' + (import.meta.env.VITE_SECONDARY_COLOR || '0B8AC8'),
      accent: '#E53935',
      error: '#D32F2F',
      info: '#0288D1',
      success: '#2E7D32',
      "on-success": '#ffffff',
      warning: '#ED6C02',
    }
  }
}

export default themeConfig
